export const logoutUrl = `${window.location.origin}/kirjaudu-ulos`
export const redirectAuthCallbackUrl = `${window.location.origin}/kirjaudu`

export const almaTunnusConfig = {
  domain: process.env.ENV === 'production' ? 'tunnus.almamedia.fi' : 'tunnus-dev.almamedia.net',
  audience: process.env.ENV === 'production' ? 'https://tunnus.almamedia.fi' : 'https://tunnus-dev.almamedia.net',
  clientID: process.env.ENV === 'production' ? 'EPFDTqLh3sZ61z9PfleoiXS6JIA8ew50' : '2DFrijtmyw3Md026HUJRX2dlIP2ZyKDC',
  redirectUri: redirectAuthCallbackUrl,
  logoutUrl: logoutUrl,
  scope: 'openid profile email create:session offline_access',
  realm: 'Almatunnus',
  loginNotification: false
}
export const almaTunnusUtils = {
  async formUniqueIdFromInputString(inputString: string): Promise<string> {
    const buffer = new TextEncoder().encode(inputString)
    const hash = await crypto.subtle.digest('SHA-256', buffer)
    const hashArray = Array.from(new Uint8Array(hash))
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')

    const id = [hashHex.substring(0, 8), hashHex.substring(8, 16), hashHex.substring(16, 24), hashHex.substring(24, 32)].join('-')

    return id
  }
}
